import type { IProduct } from '../types/products'

export function minimumQuantity(product?: Pick<IProduct, 'minimumOrderQuantity'>) {
  const value = Number(product?.minimumOrderQuantity ?? 1)
  return Number.isSafeInteger(value) && value >= 1 ? value : 1
}

export function isBelowMinimum(product: IProduct) {
  const quantity = Number(product.quantity ?? 0)
  return !Number.isSafeInteger(quantity) || quantity < minimumQuantity(product)
}

// Refresh only the minimum: cart prices may include selected ingredients.
export function refreshCartMinimums(cart: IProduct[], products: IProduct[]) {
  const catalog = new Map(products.map(product => [product._id, product]))
  return cart.map(item => ({
    ...item,
    minimumOrderQuantity: minimumQuantity(catalog.get(item._id) ?? item),
  }))
}
